<template lang="pug">
v-sheet(color="secondary", align="right")
  v-sheet(color="secondary")
    v-row.pl-2.pr-2(no-gutters="")
      v-col(cols="2")
        .blue--text.headline(align="left")
          span {{ counter.code }}
      v-col(cols="2")
        div(
          align="left",
          :disabled="!['GA', 'RM', 'CC'].includes(selectedUser.role)"
        )
          v-btn(icon="", v-if="myFeatures.eligibleFeatures.includes('REPORT')")
            v-icon(
              v-if="counter.status === STATUSES.OPEN",
              @click="vibrate(); closeCounter()",
              large="",
              color="green"
            ) mdi-toggle-switch
            v-icon(
              v-else="",
              large="",
              @click="vibrate(); openCounter()",
              color="red"
            ) mdi-toggle-switch-off
      v-col(cols="6")
        //
          TODO NEXT RELEASE <span :key="ageKey" v-if="counter.status === STATUSES.OPEN">
          1hr
          <strong class="blink">:</strong> 5m
          </span>
      v-col(cols="2")
        div(align="left")
          counter-navigator(:counter="counter")
  .box
    v-row.pr-1.pl-1(no-gutters="")
      v-col
        div(align="center")
          strong {{ counter.name }}
    template(v-if="counter.status === STATUSES.OPEN")
      v-row.pl-1.pr-1(no-gutters="")
        v-col
          span On-counter:
          code(
            v-bind:class="{ blink: getFilteredOrdersLength(counter, STATUSES.QUEUED) }"
          ) {{ getFilteredOrdersLength(counter, STATUSES.QUEUED) }}
      v-row.pl-1.pr-1(
        v-if="myFeatures.eligibleFeatures.includes('WORKFLOW')",
        no-gutters=""
      )
        v-col
          span In-progress:
          code(
            v-bind:class="{ blink: getFilteredOrdersLength(counter, STATUSES.PREPON) }"
          ) {{ getFilteredOrdersLength(counter, STATUSES.PREPON) }}
      v-row.pl-1.pr-1(
        v-if="myFeatures.eligibleFeatures.includes('WORKFLOW')",
        no-gutters=""
      )
        v-col
          span Ready2Pick:
          code(
            v-bind:class="{ blink: getFilteredOrdersLength(counter, STATUSES.READY) }"
          ) {{ getFilteredOrdersLength(counter, STATUSES.READY) }}
      v-row.pl-1.pr-1(
        v-if="myFeatures.eligibleFeatures.includes('WORKFLOW')",
        no-gutters=""
      )
        v-col
          span In-Transit:
          code {{ getFilteredOrdersLength(counter, STATUSES.INTRANSIT) }}
      v-row.pl-1.pr-1(
        v-if="myFeatures.eligibleFeatures.includes('WORKFLOW')",
        no-gutters=""
      )
        v-col
          span Served:
          code {{ getFilteredOrdersLength(counter, STATUSES.SERVED) }}
      v-row.pl-1.pr-1(no-gutters="")
        v-col
          span Cleared:
          code {{ getFilteredOrdersLength(counter, STATUSES.CLEARED) }}
</template>
<script>
import { storeMixin } from "../../mixins/storeMixin.js";
import CounterNavigator from "../menus/CounterNavigator.vue";
export default {
  name: "ezcounter",
  mixins: [storeMixin],
  props: { counter: Object },
  components: { CounterNavigator },
  data() {
    return {};
  },
  methods: {
    getFilteredOrdersLength(counter, status) {
      return this.restaurantOrders.filter(
        (o) => o._counterKey === counter.id && o.status == status
      ).length;
    },
    openCounter() {
      if (this.selectedRestaurant.status === this.STATUSES.OPEN) {
        this.counter.status = this.STATUSES.OPEN;
        const report = {
          _groupKey: this.selectedGroup.id,
          _restaurantKey: this.selectedRestaurant.id,
          _counterKey: this.counter.id,
          _restaurantReportKey: this.restaurantReport.id,
          code: this.counter.code,
          inCharge: this.counter.chefName,
          _inChargeId: this.counter._chefId,
          reportType: "counter",
          openTS: Date.now(),
          closedTS: "",
          reportText: "",
          status: this.STATUSES.OPEN,
        };
        this.createDoc({ collectionName: "reports", doc: report });
        this.updateFields({
          collectionName: "counters",
          docId: this.counter.id,
          subDoc: { status: this.counter.status },
        });
      } else {
        this.$emit(
          "openerror",
          "Counter can't be opened before the restaurant. Please try after the restaurant is opened."
        );
      }
    },
    closeCounter() {
      this.selectCounter(this.counter);
      const report = this.counterReport(this.counter.id);
      if (report._inChargeId !== this.selectedUser.id) {
        const message = `Counter can be closed by only whoever opened it(${report.inCharge}). Please check if you have opened it and try closing again`;
        this.$emit("openerror", message);
      } else {
        const openOrders = this.counterOrders.filter(
          (o) => o.status < this.STATUSES.PAIDINSERVICE
        );
        if (openOrders.length === 0) {
          this.gotoCounterReportForCloseout();
        } else {
          const message = `There are still ${openOrders.length} orders of this counter yet to be billed. Please wait until all orders are billed.`;
          this.$emit("openerror", message);
        }
      }
    },
    gotoCounterReportForCloseout() {
      this.selectCounter(this.counter);
      this.$router.push({
        name: "counterReport",
        params: {
          restaurantId: this.counter._restaurantKey,
          counterId: this.counter.id,
          reportId: this.counterReport(this.counter.id).id,
        },
      });
    },
  },
};
</script>
<style >
.unwrapped {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.blink {
  animation: blinkingText 1s infinite;
}
@keyframes blinkingText {
  0% {
    color: red;
  }
  50% {
    color: transparent;
  }
  100% {
    color: red;
  }
}
.box {
  border: solid 1px;
  padding: 2px;
  margin: 4px;
}
</style>